class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector("#predictive-search");

    this.input.addEventListener(
      "input",
      this.debounce((event) => {
        this.onChange(event);
      }, 300).bind(this)
    );

    this.input.addEventListener(
      "focus",
      this.debounce((event) => {
        this.onFocus(event);
      }, 300).bind(this)
    );
  }

  onChange() {
    const searchTerm = this.input.value.trim();
    this.getSearchResults(searchTerm);
  }

  onFocus() {
    document.body.classList.add("overlay--search-active");
  }

  getSearchResults(searchTerm) {
    const searchURL = searchTerm.length
      ? `/search/suggest?q=${searchTerm}&section_id=predictive-search&resources[type]=product`
      : "?section_id=predictive-search&resources[type]=product";
    fetch(`${searchURL}`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          throw error;
        }
        return response.text();
      })
      .then((text) => {
        const resultsContainer = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector("#shopify-section-predictive-search");
        const resultsMarkup = resultsContainer?.innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        const viewAllLink = this.predictiveSearchResults?.querySelector(
          ".predictive-search__view-all"
        );
        const href = window.location.origin;
        viewAllLink?.setAttribute("href", `${href}/search?q=${searchTerm}`);

        if (window.Trustpilot) {
          this.predictiveSearchResults
            .querySelectorAll(".trustpilot-widget")
            .forEach(function (widget) {
              window.Trustpilot.loadFromElement(widget);
            });
        }
        this.open();
      })
      .catch((error) => {
        // this.close();
        throw error;
      });
  }

  open() {
    this.predictiveSearchResults.style.display = "block";
  }

  close() {
    this.predictiveSearchResults.style.display = "none";
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define("predictive-search", PredictiveSearch);
